<template>
    <div class="contentful-rich-text-container">
        <ContentfulRichTextRenderer
            :document="document"
            :class="customClass"
        />
    </div>
</template>

<script>
import ContentfulRichTextRenderer from "contentful-rich-text-vue-renderer";

export default {
    name: "ContentfulRichText",
    components: {
        ContentfulRichTextRenderer,
    },
    props: {
        document: {
            type: Object,
            required: true,
        },
        customClass: {
            type: String,
            default: "",
        },
    },
};
</script>

<style lang="scss" scoped>
.contentful-rich-text-container {
    h1 {
        margin-top: 0.5em;
    }
    li {
        margin-top: 0.1em;
    }
    
    li p {
        margin: 0;
    }
    ul, ol {
        margin-bottom: 1em;
    }
    h3 {
        margin-top: 1em;
        margin-bottom: 0.5em;
    }
    
    hr {
        margin-top: 1em;
        margin-bottom: 1em;
    }
    
    // Styles for lists
    ul, ol {
        padding-left: 1.5em;
    }
    
    // Styles for paragraphs
    p {
        margin-bottom: 0.5em;
        line-height: 1.5;
    }
    
    // Styles for links
    a {
        color: var(--v-primary-base);
        text-decoration: none;
        
        &:hover {
            text-decoration: underline;
        }
    }
    
    // Styles for bold text
    strong, b {
        font-weight: 600;
    }
    
    // Styles for italic text
    em, i {
        font-style: italic;
    }
    
    // Styles for tables
    table {
        border-collapse: collapse;
        width: 100%;
        margin: 1em 0;
        
        th, td {
            border: 1px solid #ddd;
            padding: 8px;
            text-align: left;
        }
        
        th {
            background-color: #f5f5f5;
            font-weight: 600;
        }
    }
    
    // Styles for blockquotes
    blockquote {
        border-left: 4px solid var(--v-primary-base);
        margin: 1em 0;
        padding-left: 1em;
        font-style: italic;
        color: #666;
    }
    
    // Styles for code
    code {
        background-color: #f5f5f5;
        padding: 2px 4px;
        border-radius: 3px;
        font-family: monospace;
        font-size: 0.9em;
    }
    
    pre {
        background-color: #f5f5f5;
        padding: 1em;
        border-radius: 4px;
        overflow-x: auto;
        
        code {
            background-color: transparent;
            padding: 0;
        }
    }
}
</style>
